import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import JBImage from 'components/essentials/JBImage';
import getAltFromSrc from 'commons/getAltFromSrc';
import { getThumbnailImageImgixPropsForPhoto } from '../PDPDesktopHeroGallery/helpers/imgix-props';
import PDPVideoPosterFrame from '../PDPVideoPosterFrame';

// Thumbnail tile shared by the rail and the expanded gallery grid
const PDPGalleryRevampLifestyleThumb = t0 => {
  const $ = _c(25);
  const {
    ariaLabel,
    borderClass: t1,
    children,
    className,
    icon,
    imgClassName: t2,
    imgSize: t3,
    isSelected: t4,
    onClick,
    src,
    srcType: t5,
    videoUrl
  } = t0;
  const borderClass = t1 === undefined ? "border-gray-light7" : t1;
  const imgClassName = t2 === undefined ? "h-full w-full object-cover" : t2;
  const imgSize = t3 === undefined ? null : t3;
  const isSelected = t4 === undefined ? false : t4;
  const srcType = t5 === undefined ? "studio" : t5;
  let t6;
  if ($[0] !== borderClass || $[1] !== className || $[2] !== isSelected) {
    t6 = classNames("relative items-center flex justify-center overflow-hidden rounded border-solid bg-white", "hover:cursor-pointer hover:border-brand-dark focus-visible:outline-brand", isSelected ? "border-2 border-brand-dark" : classNames("border", borderClass), className);
    $[0] = borderClass;
    $[1] = className;
    $[2] = isSelected;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== imgClassName || $[5] !== src || $[6] !== videoUrl) {
    t7 = !src && <PDPVideoPosterFrame className={imgClassName} src={videoUrl} />;
    $[4] = imgClassName;
    $[5] = src;
    $[6] = videoUrl;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== imgClassName || $[9] !== imgSize || $[10] !== src || $[11] !== srcType) {
    t8 = !!src && (srcType === "cylindo" ? <img className={imgClassName} src={src} alt={getAltFromSrc(src)} /> : <JBImage className={imgClassName} forPage="pdp" lazy={false} alt={getAltFromSrc(src)} {...getThumbnailImageImgixPropsForPhoto({
      src,
      type: srcType
    })} {...imgSize} />);
    $[8] = imgClassName;
    $[9] = imgSize;
    $[10] = src;
    $[11] = srcType;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== children) {
    t9 = !!children && <div className="text-xs font-bold text-gray">{children}</div>;
    $[13] = children;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== icon) {
    t10 = !!icon && <div className="absolute items-center flex justify-center inset-0">{icon}</div>;
    $[15] = icon;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== ariaLabel || $[18] !== onClick || $[19] !== t10 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t11 = <button type="button" aria-label={ariaLabel} onClick={onClick} className={t6}>{t7}{t8}{t9}{t10}</button>;
    $[17] = ariaLabel;
    $[18] = onClick;
    $[19] = t10;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};
PDPGalleryRevampLifestyleThumb.propTypes = {
  ariaLabel: PropTypes.string,
  borderClass: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.node,
  imgClassName: PropTypes.string,
  imgSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }),
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  src: PropTypes.string,
  srcType: PropTypes.string,
  videoUrl: PropTypes.string
};
export default PDPGalleryRevampLifestyleThumb;